import * as Yup from "yup";

export const registerValidationSchema = Yup.object().shape({
  uid: Yup.string()
    .min(6, "6자 이상 입력해주세요.")
    .matches(
      /^[a-zA-Z0-9]*$/,
      "아이디는 영문 혹은 영문과 숫자 조합으로 입력해주세요."
    )
    .required("아이디를 입력해주세요."),
  upass: Yup.string()
    // .length(8, "8자 이상 입력해주세요.")
    .matches(/^.{8,}$/, "최소 8자 이상 입력해주세요.")
    .required("비밀번호를 입력해주세요."),
  reupass: Yup.string()
    .oneOf([Yup.ref("upass")], "비밀번호가 일치하지 않습니다.")
    .required("비밀번호를 입력해주세요."),
  name: Yup.string().required("이름을 입력해주세요."),
  email: Yup.string()
    .email("이메일 형식을 다시 확인해주세요.")
    .required("이메일을 입력해주세요."),
  phone: Yup.string()
    .min(10, "10자 이상, 숫자만 입력해주세요.")
    .max(11, "11자 이하, 숫자만 입력해주세요.")
    .matches(
      /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/,
      "연락처 형식을 확인해주세요."
    )
    .required("연락처를 입력해주세요."),
});

export const editUserInfoValidationSchema = Yup.object().shape({
  uid: Yup.string()
    .min(6, "6자 이상 입력해주세요.")
    .matches(
      /^[a-zA-Z0-9]*$/,
      "아이디는 영문 혹은 영문과 숫자 조합으로 입력해주세요."
    )
    .required("아이디를 입력해주세요."),
  name: Yup.string().required("이름을 입력해주세요."),
  email: Yup.string()
    .email("이메일 형식을 다시 확인해주세요.")
    .required("이메일을 입력해주세요."),
});

export const findPwValidationSchema = Yup.object().shape({
  uid: Yup.string()
    .matches(
      /^[a-zA-Z0-9]*$/,
      "아이디는 영문 혹은 영문과 숫자 조합으로 입력해주세요."
    )
    .required("등록한 아이디를 입력해주세요."),
  phone: Yup.string()
    .min(10, "10자 이상, 숫자만 입력해주세요.")
    .max(11, "11자 이하, 숫자만 입력해주세요.")
    .matches(
      /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/,
      "연락처 형식을 확인해주세요."
    )
    .required("연락처를 입력해주세요."),
});

export const findPwReqValidationSchema = Yup.object().shape({
  num: Yup.string()
    .matches(/^([0-9]{6})$/, "인증번호 숫자 6자리를 입력해주세요.")
    .required("인증번호 6자리를 입력해주세요."),
  upass: Yup.string()
    .matches(/^.{8,}$/, "최소 8자 이상 입력해주세요.")
    .required("등록할 새 비밀번호를 입력해주세요."),
  reupass: Yup.string()
    .oneOf([Yup.ref("upass"), null], "비밀번호가 일치하지 않습니다.")
    .required("동일한 비밀번호를 다시 입력해주세요."),
});

export const findIdValidationSchema = Yup.object().shape({
  name: Yup.string().required("등록한 이름을 입력해주세요."),
  phone: Yup.string()
    .min(10, "10자 이상, 숫자만 입력해주세요.")
    .max(11, "11자 이하, 숫자만 입력해주세요.")
    .matches(
      /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/,
      "연락처 형식을 확인해주세요."
    )
    .required("연락처를 입력해주세요."),
});

export const findIdReqValidationSchema = Yup.object().shape({
  num: Yup.string()
    .matches(/^([0-9]{6})$/, "인증번호 숫자 6자리를 입력해주세요.")
    .required("인증번호 6자리를 입력해주세요."),
});

export const GPTypeOneSchema = ({ min, rounding, max }) => {
  return Yup.object().shape({
    cnt: Yup.number()
      .required("주문 수량은 필수 입니다.")
      .transform((value, originalValue) => {
        return isNaN(originalValue) ? undefined : Number(originalValue);
      })
      .test("roundTest", "묶음 단위를 확인하세요", (value, context) => {
        let check = true;

        if (value % rounding) {
          check = false;
        }

        if (!check) {
          return context.createError({
            path: context.path,
            message: `${rounding} 단위로 주문 가능합니다.`,
          });
        }
        return check;
      })
      .test("is-not-nan", "숫자만 입력해주세요.", (value) => !isNaN(value))
      .min(min || 500, `최소 주문 수량은 ${min || 500}개 입니다.`)
      .max(max || 9999999, `최대 주문 수량은 ${max || 99999999}개 입니다.`),
    company: Yup.string().required("업체명은 필수입니다."),
    name: Yup.string().required("담당자명은 필수입니다."),
    phone: Yup.string().required("연락처는 필수입니다."),
    email: Yup.string().required("이메일은 필수입니다."),
    doro_addr: Yup.string().required("주소 필수입니다."),
    detail_addr: Yup.string().required("상세주소는 필수입니다."),
    editYn: Yup.string().required("디자인 작업 선택은 필수입니다."),
    memo: Yup.string(),
    file: Yup.mixed()
      .required("파일을 업로드해주세요.")
      .test("is-fileList", "파일을 업로드해주세요.", (value) => {
        if (!value) return false; // 파일이 없는 경우
        if (Object.prototype.toString.call(value) === "[object File]") {
          return Object.prototype.toString.call(value) === "[object File]";
        } else {
          return Object.prototype.toString.call(value) === "[object FileList]";
        }
      }),
  });
};

export const GPTypeTwoSchema = Yup.object().shape({
  company: Yup.string().required("회사명은 필수입니다."),
  name: Yup.string().required("신청자명은 필수입니다."),
  phone: Yup.string().required("연락처는 필수입니다."),
  cnt: Yup.number()
    .transform((value, originalValue) => {
      return isNaN(originalValue) ? undefined : Number(originalValue);
    })
    .test("is-not-nan", "숫자만 입력해주세요.", (value) => !isNaN(value))
    .required("교육 참가 인원은 필수 입니다.")
    .min(1, "최소 참가 인원은 1명 입니다."),
  check: Yup.boolean()
    .isTrue("정보이용 동의에 체크해주세요.")
    .required("정보이용 동의에 체크해주세요."),
});

export const GPTypeThirdSchema = Yup.object().shape({
  company: Yup.string().required("회사명은 필수입니다."),
  name: Yup.string().required("신청자명은 필수입니다."),
  phone: Yup.string().required("연락처는 필수입니다."),
  email: Yup.string()
    .email("올바른 이메일 형식이 아닙니다.")
    .required("이메일은 필수입니다."),
  memo: Yup.string().required("문의 내용은 필수입니다."),
  file: Yup.mixed()
    .required("파일을 업로드해주세요.")
    .test("is-fileList", "파일을 업로드해주세요.", (value) => {
      if (!value) return false; // 파일이 없는 경우
      if (Object.prototype.toString.call(value) === "[object File]") {
        return Object.prototype.toString.call(value) === "[object File]";
      } else {
        return Object.prototype.toString.call(value) === "[object FileList]";
      }
    }),
  check: Yup.boolean()
    .isTrue("정보이용 동의에 체크해주세요.")
    .required("정보이용 동의에 체크해주세요."),
});

export const GPTypeFourSchema = Yup.object().shape({
  company: Yup.string().required("회사명은 필수입니다."),
  name: Yup.string().required("신청자명은 필수입니다."),
  phone: Yup.string().required("연락처는 필수입니다."),
  email: Yup.string()
    .email("올바른 이메일 형식이 아닙니다.")
    .required("이메일은 필수입니다."),
  memo: Yup.string().required("문의 내용은 필수입니다."),
  file: Yup.mixed()
    .required("파일을 업로드해주세요.")
    .test("is-fileList", "파일을 업로드해주세요.", (value) => {
      if (!value) return false; // 파일이 없는 경우
      if (Object.prototype.toString.call(value) === "[object File]") {
        return Object.prototype.toString.call(value) === "[object File]";
      } else {
        return Object.prototype.toString.call(value) === "[object FileList]";
      }
    }),
  doro_addr: Yup.string().required("주소 필수입니다."),
  detail_addr: Yup.string().required("상세주소는 필수입니다."),
  check: Yup.boolean()
    .isTrue("정보이용 동의에 체크해주세요.")
    .required("정보이용 동의에 체크해주세요."),
});
